import { render, staticRenderFns } from "./CurriculumListNEC.vue?vue&type=template&id=d3dc6f00&scoped=true&"
import script from "./CurriculumListNEC.vue?vue&type=script&lang=ts&"
export * from "./CurriculumListNEC.vue?vue&type=script&lang=ts&"
import style0 from "./CurriculumListNEC.vue?vue&type=style&index=0&id=d3dc6f00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3dc6f00",
  null
  
)

export default component.exports